import React from 'react';
import './ChainName.less';

export const ChainName = ({text}) => {
	return <h1 className="chain-name">{text}</h1>;
};
